import { defineMessages } from 'react-intl'

import { SALE_CHANNEL } from './constants'

export const saleChannelMessages = defineMessages({
  /*@ts-expect-error ts(2322) FIXME*/
  [SALE_CHANNEL.ONLINE]: {
    id: 'salechannel.online',
    defaultMessage: 'Online'
  },
  [SALE_CHANNEL.POS]: {
    id: 'salechannel.pos',
    defaultMessage: 'PoS'
  },
  [SALE_CHANNEL.KOLORS_MX]: {
    id: 'salechannel.kolors-mx',
    defaultMessage: 'Kolors MX'
  },
  [SALE_CHANNEL.KOLORS_US]: {
    id: 'salechannel.kolors-us',
    defaultMessage: 'Kolors US'
  }
})
